export default "__VITE_ASSET__DIflxrPZ__"